import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Step from "@material-ui/core/Step";
import StepContent from "@material-ui/core/StepContent";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { API_ROOT } from "../../../../constants/actionTypes";
import { postAsync } from "../../services/api_util";
import AmountSelector from "./amount_selector";
import CountrySelector from "./country_selector";
import DonationEntry from "./enter_donation_amount";
import EmailEntry from "./enter_email";
import MobileValidator from "./mobile_validator";
import PaymentDetails from "./payment_details";
import AddressForm from "./address_details"
import { setActiveStep, addValidatedStep, setErrors, setLoading, resetTxn, fetchAddressCountries } from "./topupSlice";
import TxnConfirmation from "./txn_confirmation";
import TxnResult from "./txn_result";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Alert } from "@material-ui/lab";
import SomethingWentWrong from "../../components/somethingWentWrong";
import { setNavIndex } from "../../../secured-app/uiSlice";
import { setTabPosition } from "../../uiSlice";
import { getToken } from "../../../../middleware/storage";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepper-root": {
      padding: 0,
    },
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: 20,
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
    float: "right",
  },
  resetContainer: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(3),
    },
  },
  resetBtn: {
    borderRadius: 20,
    marginTop: theme.spacing(2),
    float: "right",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}));

const facState = { state: "pending", data: "" };

export default function TopupStepper() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const {
    activeStep,
    validatedSteps,
    txnDetails,
    errors,
    submissionDetails,
    paymentDetails,
    addressDetails,
  } = useSelector((state) => state.topup);
  const [facResponse, setFacResponse] = useState(facState);
  const token = getToken();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const steps = [
    {
      label: "Select Country",
      value: (
        <Typography color="secondary" variant="h6">
          {txnDetails.country.countryId >= 0
            ? txnDetails.country.description
            : ""}{" "}
        </Typography>
      ),
    },
    {
      label: "Enter PREPAID Mobile Number",
      value: txnDetails.carrier ? (
        <Typography color="secondary" variant="h6">
          {txnDetails.carrier.name} :{" "}
          <NumberFormat
            value={txnDetails.mobileNumber}
            format="+#(###) ### - ####"
            displayType="text"
          />
        </Typography>
      ) : (
        ""
      ),
    },
    {
      label: "Select Top Up Amount",
      value: (
        <Typography color="secondary" variant="h6">
          {txnDetails.amount > 0 ? `$${txnDetails.amount.toFixed(2)} TTD` : ""}
        </Typography>
      ),
    },
    {
      label: "Enter Donation Amount",
      value: (
        <Typography color="secondary" variant="h6">
          {txnDetails.donationAmount > 0 ? `$${txnDetails.donationAmount.toFixed(2)} TTD` : ""}
        </Typography>
      ),
    },
    { label: "Enter Card Details" },
    { label: "Billing Address Info" },
    { label: "Enter Email for Receipt" },
    { label: "Transaction Confirmation" },
  ];

  const handleNext = async () => {
    console.log(txnDetails.donationAmount);
    // if (activeStep === 3 ){
    //   console.log("here");
    //   dispatch(addValidatedStep(activeStep));
    // }
    if (activeStep === 4) {
      let isValid = true;
      for (const [key, value] of Object.entries(errors)) {
        if (value) {
          isValid = false;
        }
      }

      if (isValid) {
        dispatch(setActiveStep(1));
      }
    } else if (activeStep === 7) {
      const { tac, ppolicy } = submissionDetails;
      const { carrier, mobileNumber, coverVat, country, email } = txnDetails;
      let googleRecaptchaToken = null;
      let charityId = 0;
      if (tac && ppolicy) {
        if (!executeRecaptcha) {
          googleRecaptchaToken = null;

        }
        const googleRecaptchaToken = await executeRecaptcha('postTopup');


        if (txnDetails.charity != '') {
          charityId = txnDetails.charity.providerId;
        }
        setFacResponse({ ...facState });
        const data = {
          phoneProviderId: carrier.phoneProviderId,
          msisdn: mobileNumber,
          coverVat: coverVat,
          countryId: country.countryId,
          amount: parseFloat(txnDetails.presetSelected.amount),
          donationAmount: parseFloat(txnDetails.donationAmount),
          charityId: charityId,
          ...paymentDetails,
          billingAddress: addressDetails,
          email,
          googleRecaptchaToken,
          shouldSaveCard: paymentDetails.shouldSaveCard
        };
        dispatch(setLoading("pending"));

        let response = await postAsync(
          data,
          `${API_ROOT}Topup/PostTopupTransaction`
        );
        dispatch(setLoading("idle"));

        if (response.state === 1) {
          setFacResponse({ state: "success", data: response.data });
          dispatch(setActiveStep(1));
        } else {
          setFacResponse({ ...facState, state: "failed", msg: response.msg });
        }

      } else {
        dispatch(
          setErrors({
            ...errors,
            agreement:
              "Please agree to the Terms & Conditions and Privacy Policy to proceed",
          })
        );
      }
    } else if ([0, 1, 2, 3, 5, 6].indexOf(activeStep) !== -1) {
      dispatch(setActiveStep(1));
    }
  };

  const handleBack = () => {
    dispatch(setActiveStep(-1));
  };

  const handleReset = () => {
    dispatch(setActiveStep(0));
  };

  const validatedStep = () => {
    return validatedSteps.indexOf(activeStep) >= 0;
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return <CountrySelector handleNext={handleNext} />;
      case 1:
        return <MobileValidator handleNext={handleNext} />;
      case 2:
        return <AmountSelector handleNext={handleNext} />;
      case 3:
        return <DonationEntry handleNext={handleNext} />;
      case 4:
        return <PaymentDetails handleNext={handleNext} />;
      case 5:
        return <AddressForm handleNext={handleNext} />;
      case 6:
        return <EmailEntry handleNext={validatedStep} />;
      case 7:
        return <TxnConfirmation handleNext={validatedStep} />;

      default:
        return "Unknown step";
    }
  };

  const renderFacError = () => {
    if (facResponse.msg.length > 0) {
      return <Alert severity="error"> {facResponse.msg} </Alert>

    }
    return (
      <SomethingWentWrong
        redirect={token ? "/user/topup" : "/quicktopup"}
        redirect2={token ? "/user/contactus" : "/contact"}
        redirectText="Try Again"
        redirectText2="Contact Us"
        onClick1={() => window.location.reload()}
        onClick2={
          token
            ? () => dispatch(setNavIndex(6))
            : () => dispatch(setTabPosition(6))
        }
      />
    )
  }

  return (

    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel optional={step.value}>{step.label}</StepLabel>
            <StepContent>
              {getStepContent(index)}
              <div style={{ marginTop: 20 }}>{facResponse.state === "failed" && index == steps.length - 1 && renderFacError()}</div>
              <div className={classes.actionsContainer}>
                <div>
                  {activeStep > 0 && (
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className={classes.button}
                    >
                      Back
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                    disabled={validatedSteps.indexOf(activeStep) === -1}
                  >
                    {activeStep === steps.length - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <div>
            {facResponse.state === "success" &&
              <TxnResult
                facResponse={facResponse}
              />
            }
            <Button
              onClick={handleReset}
              className={classes.resetBtn}
              color="primary"
              variant="contained"
            >
              New Transaction
            </Button>
          </div>
        </Paper>
      )}
    </div>
  );
}
